export default __webpack_public_path__ + "static/Theinhardt-Italic-subset-548bf77cbf409dddb1c4a42496b6608c.woff2";